import React, { useState } from 'react';
import styled from 'styled-components';
import CenteredLayout from '../../layout/CenteredLayout';
import MultiImageAdd from '../../components/MultiImageAdd';

const MultiImageAddTest: React.FC = () => {
  const [images, setImages] = useState<string[]>([]);

  const handleImageAdd = (file: File) => {
    // 실제 구현에서는 서버에 업로드하고 URL을 받아와야 합니다
    const imageUrl = URL.createObjectURL(file);
    setImages(prev => [...prev, imageUrl]);
  };

  const handleImageDelete = (index: number) => {
    setImages(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <CenteredLayout>
      <Container>
        <Title>MultiImageAdd 컴포넌트 테스트</Title>
        
        <TestSection>
          <SectionTitle>기본 사용법</SectionTitle>
          <MultiImageAdd
            imageUrls={images}
            onImageAdd={handleImageAdd}
            onImageDelete={handleImageDelete}
            maxImages={5}
          />
          <Info>현재 이미지 개수: {images.length}/5</Info>
        </TestSection>

        <TestSection>
          <SectionTitle>작은 크기 (80px)</SectionTitle>
          <MultiImageAdd
            imageUrls={images}
            itemSize={80}
            onImageAdd={handleImageAdd}
            onImageDelete={handleImageDelete}
            maxImages={8}
          />
        </TestSection>

        <TestSection>
          <SectionTitle>큰 크기 (150px)</SectionTitle>
          <MultiImageAdd
            imageUrls={images}
            itemSize={150}
            onImageAdd={handleImageAdd}
            onImageDelete={handleImageDelete}
            maxImages={3}
          />
        </TestSection>

        <TestSection>
          <SectionTitle>비활성화 상태</SectionTitle>
          <MultiImageAdd
            imageUrls={images}
            onImageAdd={handleImageAdd}
            onImageDelete={handleImageDelete}
            disabled={true}
          />
        </TestSection>

        <Actions>
          <ResetButton onClick={() => setImages([])}>
            모든 이미지 삭제
          </ResetButton>
        </Actions>
      </Container>
    </CenteredLayout>
  );
};

const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 30px;
  color: #333;
`;

const TestSection = styled.div`
  margin-bottom: 40px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 15px;
  color: #555;
`;

const Info = styled.p`
  margin-top: 10px;
  font-size: 14px;
  color: #666;
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 30px;
`;

const ResetButton = styled.button`
  padding: 10px 20px;
  background-color: #e53e3e;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background-color: #c53030;
  }
`;

export default MultiImageAddTest;
